// nosemgrep: no-legacy-api-store
import apiStore from '@/legacy/store/modules/apiBuilder'
import { LlmFeedback } from './types'

export const useLlmFeedbackApi = apiStore<LlmFeedback>(
  'llmFeedbackApi',
  '/api/llm/monitoring/feedback'
)
